import { render, staticRenderFns } from "./AddNewNoteModalInNotesTab.vue?vue&type=template&id=06d4643a"
import script from "./AddNewNoteModalInNotesTab.vue?vue&type=script&lang=js"
export * from "./AddNewNoteModalInNotesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports